import styled from "styled-components";

export const StyledContainer = styled("div")`
  display:flex;
  text-align: center;
  justify-content: center;
  align-items: center;
`;
